// Usage: myValidator = Object.create(BaseValidator)
// myValidator.defineOrOverWriteMethods = …
// myValidator.init()

// All children validators, except for `BaseValidator` are meant to be used directly
// i.e. not further inherited, hence the lowercase naming of children validators

// More information about OLOO style
// https://github.com/getify/You-Dont-Know-JS/blob/master/this%20%26%20object%20prototypes/ch6.md

const BaseValidator = {
  // We are doing this so explicitly here to be able to pass these directly
  // to the components as props and not have it change this
  init() {
    this.isValid = this.isValid.bind(this);
    this.isValidAndOptional = this.isValidAndOptional.bind(this);
    return this;
  },

  // Overwrite this method with your custom behavior
  // Default is to match against validateAgainstRegex, but feel free to overwrite it
  isValid(input) {
    if (input == null) {
      return false;
    }
    return this.validateAgainstRegex.test(`${input}`);
  },

  // Use the same validation as isValid, but allows empty strings, too
  isValidAndOptional(input) {
    if (this.validateAgainstOptionalRegex) {
      return this.validateAgainstOptionalRegex.test(`${input}`);
    }

    if (input === "") {
      return true;
    }

    return this.isValid(input);
  },

  // Invalid by default
  validateAgainstRegex: /$x^/,
};

export default BaseValidator;
